import { memo, useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { CheckBox } from '../../components';

import {
  EVENT_TYPE_OHE,
  EVENT_TYPE_SHPE,
  EVENT_TYPE_PHA,
  EVENT_TYPE_PHA_FLY,
  EVENT_TYPE_CMR,
  EVENT_TYPE_CMR_FLY,
  EVENT_TYPE_SPECIALTY_HEARING,
} from '../../../constants/eventTypes';

import { THEME, COLOR } from '../../../constants/styles';

const PreReqs = memo((props) => {
  const [phaChecked, setPhaChecked] = useState(!!props.preChecked);
  const [flyPhaChecked, setFlyPhaChecked] = useState(!!props.preChecked);
  const [oheChecked, setOheChecked] = useState(!!props.preChecked);
  const [specialtyHearingChecked, setSpecialtyHearingChecked] = useState(!!props.preChecked);
  const [shpeQuestionnaireChecked, setShpeQuestionnaireChecked] = useState(!!props.preChecked);
  const [shpeAudioChecked, setShpeAudioChecked] = useState(!!props.preChecked);

  useEffect(() => {
    const preqsChecked =
      props.eventType === EVENT_TYPE_OHE
        ? !!oheChecked
        : props.eventType === EVENT_TYPE_SPECIALTY_HEARING
          ? !!specialtyHearingChecked
          : props.eventType === EVENT_TYPE_SHPE
            ? !!shpeQuestionnaireChecked && !!shpeAudioChecked
            : props.eventType === EVENT_TYPE_PHA || props.eventType === EVENT_TYPE_CMR
              ? !!phaChecked
              : props.eventType === EVENT_TYPE_PHA_FLY || props.eventType === EVENT_TYPE_CMR_FLY
                ? !!phaChecked && !!flyPhaChecked
                : true;
    props.onPreReqsChecked(preqsChecked);
  }, [
    phaChecked,
    flyPhaChecked,
    oheChecked,
    specialtyHearingChecked,
    shpeQuestionnaireChecked,
    shpeAudioChecked,
  ]);

  function handlePhaCheck() {
    setPhaChecked(!phaChecked);
  }
  function handleFlyPhaCheck() {
    setFlyPhaChecked(!flyPhaChecked);
  }
  function handleOHECheck() {
    setOheChecked(!oheChecked);
  }
  function handleSpecialtyHearingCheck() {
    setSpecialtyHearingChecked(!specialtyHearingChecked);
  }
  function handleSHPEQuestionnaireCheck() {
    setShpeQuestionnaireChecked(!shpeQuestionnaireChecked);
  }
  function handleSHPEAudioCheck() {
    setShpeAudioChecked(!shpeAudioChecked);
  }
  function renderOHERequirementsCheckbox() {
    return (
      <CheckBox
        checked={oheChecked}
        onCheck={handleOHECheck}
        label="I certify that I have reviewed my IMR and I have completed all applicable exams listed on my shop-specific checklist provided by my shop's Occ-Health POC"
      />
    );
  }
  function renderSpecialtyHearingRequirementsCheckbox() {
    return (
      <CheckBox
        checked={specialtyHearingChecked}
        onCheck={handleSpecialtyHearingCheck}
        label="I have completed my Public Health Audiogram"
      />
    );
  }
  function renderSHPERequirementsCheckbox() {
    return (
      <View style={{ justifyContent: 'center', gap: 10 }}>
        <CheckBox
          checked={shpeQuestionnaireChecked}
          onCheck={handleSHPEQuestionnaireCheck}
          label="I have completed my SHPE Questionnaire"
        />
        <CheckBox
          checked={shpeAudioChecked}
          onCheck={handleSHPEAudioCheck}
          label="I have completed an Audiogram in the last 6 months"
        />
      </View>
    );
  }
  function renderPHARequirementsCheckbox() {
    return (
      <CheckBox
        checked={phaChecked}
        onCheck={handlePhaCheck}
        labelComp={<Text>I have completed my PHAq</Text>}
      />
    );
  }
  function renderFlyPHARequirementsCheckbox() {
    return (
      <>
        <View style={{ marginBottom: 0 }}>{renderPHARequirementsCheckbox()}</View>
        <CheckBox
          checked={flyPhaChecked}
          onCheck={handleFlyPhaCheck}
          label="I have a 2992 Form on my IMR"
        />
      </>
    );
  }

  function renderBoxes() {
    if (props.eventType === EVENT_TYPE_SPECIALTY_HEARING)
      return renderSpecialtyHearingRequirementsCheckbox();
    if (props.eventType === EVENT_TYPE_OHE) return renderOHERequirementsCheckbox();
    else if (props.eventType === EVENT_TYPE_SHPE) return renderSHPERequirementsCheckbox();
    else if (props.eventType === EVENT_TYPE_PHA || props.eventType === EVENT_TYPE_CMR)
      return renderPHARequirementsCheckbox();
    else if (props.eventType === EVENT_TYPE_PHA_FLY || props.eventType === EVENT_TYPE_CMR_FLY)
      return renderFlyPHARequirementsCheckbox();
    else return null;
  }
  return (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 10,
        backgroundColor: 'rgb(248, 248, 248)',
        borderColor: COLOR.accent,
        borderWidth: 1,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'flex-start',
        paddingTop: 10,
        paddingLeft: 20,
        marginHorizontal: props.isVerticalLayout ? 10 : 0,
        marginLeft: props.isVerticalLayout ? 10 : 30,
        marginBottom: props.isVerticalLayout ? 10 : 0,
      }}
    >
      {renderBoxes()}
    </View>
  );
});

export function eventTypeHasPrereqs(eventType) {
  return (
    eventType === EVENT_TYPE_SPECIALTY_HEARING ||
    eventType === EVENT_TYPE_OHE ||
    eventType === EVENT_TYPE_SHPE ||
    eventType === EVENT_TYPE_PHA ||
    eventType === EVENT_TYPE_PHA_FLY ||
    eventType === EVENT_TYPE_CMR ||
    eventType === EVENT_TYPE_CMR_FLY
  );
}

export default PreReqs;
